import firebase from "src/Firebase"

const db = firebase.firestore()

/* ------------ GET - LIST ------------ */

export const getUnidades = idConjunto =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("unidadesHabitacionales")
    .get()

export const getUnidadesHab = (idConjunto, observer) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("unidadesHabitacionales")
    .onSnapshot(observer)

export const getUnidadH = (idConjunto, Numero) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("unidadesHabitacionales")
    .where("Numero", "==", Numero)
    .get()

export const suscriberUnits = (conjuntoID, observer) =>
  db
    .collection("conjuntos")
    .doc(conjuntoID)
    .collection("unidadesHabitacionales")
    .onSnapshot(observer)

export const validateUH = (idConjunto, value = "") =>
  db
    .collection(`conjuntos/${idConjunto}/unidadesHabitacionales`)
    .where("Numero", "==", value.toUpperCase())
    .get()

/* ------------ POST -------------- */

export const saveUnidadHab = (idConjunto, data) =>
  db
    .collection(`conjuntos/${idConjunto}/unidadesHabitacionales`)
    .doc(data.Numero)
    .set(data)

/* ------------ PATCH ------------- */

export const saveNewTipoSubC = (idConjunto, campo, newItem) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("conjuntoConfig")
    .doc("Subconjuntos")
    .update({
      [campo]: newItem,
    })

export const updateUnidad = (idConjunto, id, data) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("unidadesHabitacionales")
    .doc(id)
    .update({
      Tipo: data.Tipo,
      SubConjunto: data.SubConjunto,
    })

export const updateLastPayDate = (conjuntoUid, unidad, data) =>
  db
    .collection("conjuntos")
    .doc(conjuntoUid)
    .collection("unidadesHabitacionales")
    .doc(unidad)
    .update({
      FechaUltimoPago: new Date(data),
    })

export const bloquearPropiedad = (idconjunto, idCasa, value) =>
  db
    .collection("conjuntos")
    .doc(idconjunto)
    .collection("unidadesHabitacionales")
    .doc(idCasa)
    .update({ isActive: value })

/* ------------ PUT ---------------- */

export const updateUnidadHab = (idConjunto, data) =>
  db
    .collection(`conjuntos/${idConjunto}/unidadesHabitacionales`)
    .doc(data.Numero)
    .update(data)

export const updateUH = async (conjuntoUid, unidadId, data) => {
  try {
    await db
      .collection("conjuntos")
      .doc(conjuntoUid)
      .collection("unidadesHabitacionales")
      .doc(unidadId)
      .update(data)
  } catch (error) {
    throw new Error("No se pudo actualizar la unidad habitacional")
  }
}

/* ------------ DELETE ------------- */

export const deleteUnidadHab = (idConjunto, idDoc) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("unidadesHabitacionales")
    .doc(idDoc)
    .delete()

/* ------------ OTHERS ------------- */

export const updateIncomes = (id, idIncomes, data) =>
  db
    .collection("conjuntos")
    .doc(id)
    .collection("ingresos")
    .doc(idIncomes)
    .update({ Cobros: data })

export const getPaymentHistory = (idConjunto, id) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("ingresos")
    .where("Usuario", "==", id)
    .orderBy("Fecha", "desc")
    .get()

export const getAccountsReceivable = (idConjunto, id) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("cuentasPorCobrar")
    .where("CasaUsuario", "==", id)
    .where("FechaLimite", "<", new Date())
    .orderBy("FechaLimite", "desc")
    .orderBy("FechaRegistro", "desc")
    .get()

export const getAllIngresos = idConjunto =>
  db.collection("conjuntos").doc(idConjunto).collection("ingresos").get()

export const getAllDeudas = (idConjunto, Casa) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("cuentasPorCobrar")
    .where("CasaUsuario", "==", Casa)
    .get()

export const getConjuntoEnMora = (idConjunto, id) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("cuentasPorCobrar")
    .where("CasaUsuario", "==", id)
    .where("FechaLimite", "<", new Date())
    .limit(1)
    .get()

export const getCuentasPorCobrar = async (idConjunto, id) => {
  try {
    const snap = await db
      .collection("conjuntos")
      .doc(idConjunto)
      .collection("cuentasPorCobrar")
      .where("CasaUsuario", "==", id)
      .get()
    return snap.docs.map(doc => ({ ...doc.data(), id: doc.id }))
  } catch (err) {
    return []
  }
}

export const suscriberCuentasPorCobrar = (idConjunto, id, observer) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("cuentasPorCobrar")
    .where("CasaUsuario", "==", id)
    .onSnapshot(observer)

export const updateCuentasporCobrar = (idConjunto, id, data) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("cuentasPorCobrar")
    .doc(id)
    .update(
      typeof data === "object"
        ? data
        : {
            UsuarioId: data,
          }
    )

export const updateCuentasCobrar = (idConjunto, id, data) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("cuentasPorCobrar")
    .doc(id)
    .update({
      CasaUsuario: data,
    })

export const updatePagoPendiente = (idConjunto, pagoId, data) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("cuentasPorCobrar")
    .doc(pagoId)
    .update(data)

export const getModulos = (observer, idConjunto) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("conjuntoConfig")
    .doc("Modulos")
    .onSnapshot(observer)
